import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { GraphQLService } from './graph-ql.service';
import { map } from 'rxjs/operators';
import { BuyerIdentity } from '../models/input/buyerIdentity.model';
import { productMetaFields } from './product-queries';

@Injectable({
  providedIn: 'root',
})
export class CartsService extends GraphQLService {
  constructor() {
    super();
  }

  CreateCart(lines: { merchandiseId: string; quantity: number }[], token?: string, language?: string, email?: string) {
    const inputData: { lines: { merchandiseId: string; quantity: number }[]; buyerIdentity?: BuyerIdentity } = {
      lines: lines,
    };

    if (token) {
      const buyerIdentity: BuyerIdentity = {
        customerAccessToken: token,
      };

      if (email) {
        buyerIdentity.email = email;
      }
      inputData['buyerIdentity'] = buyerIdentity;
    }

    const mutation = this.client.mutation(`@inContext(language: ${language})`, (root: any) => {
      root.add('cartCreate', { args: { input: inputData } }, (cartCreate: any) => {
        cartCreate.add('userErrors', (userErrors: any) => {
          userErrors.add('message'), userErrors.add('field');
        });
        cartCreate.add('cart', (checkout: any) => {
          this.addCartFields(checkout);
        });
      });
    });

    return from(this.client.send(mutation)).pipe(
      map((a: any) => {
        return a['data'].cartCreate.cart;
      })
    ) as Observable<any>;
    // return from(this.client.send(mutation, { input: { lines: [_lineItemForCheckout] } })).pipe(map(({ data }) => data.cartCreate.cart));
  }

  UpdateBuyerIdentity(token: string, cartId: string, language?: string, email?: string) {
    const buyerIdentity: BuyerIdentity = {
      customerAccessToken: token,
    };

    if (email) {
      buyerIdentity.email = email;
    }

    const mutation = this.client.mutation(`@inContext(language: ${language})`, (root: any) => {
      root.add('cartBuyerIdentityUpdate', { args: { buyerIdentity, cartId } }, (update: any) => {
        update.add('userErrors', (userErrors: any) => {
          userErrors.add('message');
          userErrors.add('field');
        });
        update.add('cart', (checkout: any) => {
          this.addCartFields(checkout);
        });
      });
    });

    return from(this.client.send(mutation)).pipe(
      map((a: any) => {
        const data = a['data'].cartBuyerIdentityUpdate;
        if (data.userErrors.length) {
          throw new Error(data.userErrors);
        }
        return data.cart;
      })
    ) as Observable<any>;
  }

  FetchCart(cartId: string, language?: string) {
    const query = this.client.query(`@inContext(language: ${language})`, (root: any) => {
      root.add('cart', { args: { id: cartId } }, (Cart: any) => {
        this.addCartFields(Cart);
      });
    });

    return from(this.client.send(query)).pipe(
      map((a: any) => {
        return a['data'].cart;
      })
    ) as Observable<any>;
    // return from(this.client.send(query)).pipe(map(({ data }) => data.cart));
  }

  AddLine(lines: { merchandiseId: string; quantity: number }[], cartId: string, language?: string) {
    const mutation = this.client.mutation(`@inContext(language: ${language})`, (root: any) => {
      root.add('cartLinesAdd', { args: { lines, cartId } }, (cartLinesAdd: any) => {
        cartLinesAdd.add('userErrors', (userErrors: any) => {
          userErrors.add('message'), userErrors.add('field');
        });
        cartLinesAdd.add('cart', (checkout: any) => {
          this.addCartFields(checkout);
        });
      });
    });

    return from(this.client.send(mutation)).pipe(
      map((a: any) => {
        const data = a['data'].cartLinesAdd;
        if (data.userErrors.length) {
          throw data.userErrors;
        }
        return data.cart;
      })
    ) as Observable<any>;

    // return from(this.client.send(mutation, { cartId: cartId, lines: [_lineItemForCheckout] })).pipe(
    //   map(({ data }) => data.cartLinesAdd.cart)
    // );
  }

  UpdateLine(cartId: string, cartLineId: string, amount: number, language?: string) {
    const _lineItemForCheckout = { id: cartLineId, quantity: +amount };

    const mutation = this.client.mutation(`@inContext(language: ${language})`, (root: any) => {
      root.add('cartLinesUpdate', { args: { lines: [_lineItemForCheckout], cartId } }, (cartLinesAdd: any) => {
        cartLinesAdd.add('userErrors', (userErrors: any) => {
          userErrors.add('message');
          userErrors.add('field');
        });
        cartLinesAdd.add('cart', (checkout: any) => {
          this.addCartFields(checkout);
        });
      });
    });
    return from(this.client.send(mutation)).pipe(
      map((a: any) => {
        return a['data'].cartLinesUpdate.cart;
      })
    ) as Observable<any>;
  }

  UpdateNote(cartId: string, note: string, language?: string) {
    const _note = { cartId, note };

    const mutation = this.client.mutation(`@inContext(language: ${language})`, (root: any) => {
      root.add('cartNoteUpdate', { args: { note, cartId } }, (cartLinesAdd: any) => {
        cartLinesAdd.add('userErrors', (userErrors: any) => {
          userErrors.add('message');
          userErrors.add('field');
        });
        cartLinesAdd.add('cart', (checkout: any) => {
          this.addCartFields(checkout);
        });
      });
    });
    return from(this.client.send(mutation)).pipe(
      map((a: any) => {
        return a['data'].cartNoteUpdate.cart;
      })
    ) as Observable<any>;
  }

  DeleteLine(cartId: string, cartLineId: string, language?: string) {
    const mutation = this.client.mutation(`@inContext(language: ${language})`, (root: any) => {
      root.add('cartLinesRemove', { args: { lineIds: [cartLineId], cartId } }, (cartLinesAdd: any) => {
        cartLinesAdd.add('userErrors', (userErrors: any) => {
          userErrors.add('message'), userErrors.add('field');
        });
        cartLinesAdd.add('cart', (checkout: any) => {
          this.addCartFields(checkout);
        });
      });
    });
    return from(this.client.send(mutation)).pipe(
      map((a: any) => {
        return a['data'].cartLinesRemove.cart;
      })
    ) as Observable<any>;
  }

  GetCartLines() {
    //
  }

  checkoutCreate(lines: { variantId: string; quantity: number }[], token?: string, language?: string, email?: string) {
    const inputData: { lines: { variantId: string; quantity: number }[]; buyerIdentity?: BuyerIdentity } = {
      lines: lines,
    };

    if (token) {
      const buyerIdentity: BuyerIdentity = {
        customerAccessToken: token,
        email,
      };
      inputData['buyerIdentity'] = buyerIdentity;
    }

    // const lines$ = this.client.variable('lines', '[CartLineInput!]!');
    // const input = this.client.variable('input', 'CheckoutCreateInput!');

    const mutation = this.client.mutation(`@inContext(language: ${language})`, (root: any) => {
      root.add('checkoutCreate', { args: { input: inputData } }, (buyNow: any) => {
        buyNow.add('userErrors', (userErrors: any) => {
          userErrors.add('message');
          userErrors.add('field');
          // userErrors.add('code');
        });
        buyNow.add('checkout', (checkout: any) => {
          checkout.add('webUrl');
          checkout.add('email');
          checkout.add('ready');
          checkout.add('buyerIdentity', (i: any) => {
            i.add('countryCode');
          });
        });
      });
    });

    return from(this.client.send(mutation)).pipe(
      map((a: any) => {
        const data = a['data'].checkoutCreate;
        if (data.userErrors.length) {
          throw data.userErrors;
        }
        return data.checkout;
      })
    ) as Observable<any>;
  }

  cartDiscountCodesUpdate(cartId: string, discountCodes: string[], language?: string) {
    const args: { cartId: string; discountCodes?: string[] } = { cartId };

    if (discountCodes) {
      args['discountCodes'] = discountCodes;
    }

    const mutation = this.client.mutation(`@inContext(language: ${language})`, (root: any) => {
      root.add('cartDiscountCodesUpdate', { args }, (cartLinesAdd: any) => {
        cartLinesAdd.add('userErrors', (userErrors: any) => {
          userErrors.add('message');
          userErrors.add('field');
        });
        cartLinesAdd.add('cart', (checkout: any) => {
          this.addCartFields(checkout);
        });
      });
    });
    return from(this.client.send(mutation)).pipe(
      map((a: any) => {
        return a['data'].cartDiscountCodesUpdate.cart;
      })
    ) as Observable<any>;
  }

  private addCartFields(query: any) {
    query.add('id');
    query.add('checkoutUrl');
    query.add('note');
    query.add('buyerIdentity', (identity: any) => {
      identity.add('countryCode');
    });
    query.addConnection('lines', { args: { first: 250 } }, (lines: any) => {
      lines.add('id');
      lines.add('quantity');
      lines.add('discountAllocations', (disc: any) => {
        disc.add('discountedAmount', (amm: any) => {
          amm.add('amount');
          amm.add('currencyCode');
        });
        disc.addInlineFragmentOn('CartAutomaticDiscountAllocation', (c: any) => {
          c.add('title');
        });
        disc.addInlineFragmentOn('CartCodeDiscountAllocation', (c: any) => {
          c.add('code');
        });
      });
      lines.add('cost', (e: any) => {
        e.add('amountPerQuantity', (t: any) => {
          t.add('amount');
          t.add('currencyCode');
        });
        e.add('compareAtAmountPerQuantity', (t: any) => {
          t.add('amount');
          t.add('currencyCode');
        });
        e.add('totalAmount', (t: any) => {
          t.add('amount');
          t.add('currencyCode');
        });
        e.add('subtotalAmount', (t: any) => {
          t.add('amount');
          t.add('currencyCode');
        });
      });
      lines.add('merchandise', (merchandise: any) => {
        merchandise.addInlineFragmentOn('ProductVariant', (variant: any) => {
          variant.add('title');
          variant.add('availableForSale');
          variant.add('quantityAvailable');
          variant.add('currentlyNotInStock');
          variant.add('sku');

          variant.add('product', (p: any) => {
            p.add('title');
            p.add('handle');
            p.add('vendor');
            p.add('productType');

            p.addConnection('collections', { args: { first: 1 } }, (collection: any) => {
              collection.add('id');
              collection.add('title');
              collection.add('handle');
            });
            p.add('metafields', { args: { identifiers: productMetaFields } }, (metafields: any) => {
              metafields.add('key');
              metafields.add('value');
              metafields.add('type');
            });
            // p.add('metafield', { args: { namespace: 'specs', key: 'product_unit' } }, (metafields: any) => {
            //   metafields.add('key');
            //   metafields.add('value');
            // });
          });
          variant.add('priceV2', (p: any) => {
            p.add('amount');
            p.add('currencyCode');
          });
          variant.add('selectedOptions', (o: any) => {
            o.add('name');
            o.add('value');
          });
          variant.add('image', (image: any) => {
            image.add('src');
            image.add('id');
            image.add('altText');
            image.add('url', { args: { transform: { crop: this.client.enum('CENTER'), maxWidth: 400, maxHeight: 400 } } });
          });
        });
      });
    });

    query.add('discountCodes', (costs: any) => {
      costs.add('applicable');
      costs.add('code');
    });
    query.add('cost', (costs: any) => {
      costs.add('subtotalAmount', (subtotal: any) => {
        subtotal.add('amount');
        subtotal.add('currencyCode');
      });
      costs.add('totalAmount', (subtotal: any) => {
        subtotal.add('amount');
        subtotal.add('currencyCode');
      });
      costs.add('totalTaxAmount', (subtotal: any) => {
        subtotal.add('amount');
        subtotal.add('currencyCode');
      });
      costs.add('totalDutyAmount', (subtotal: any) => {
        subtotal.add('amount');
        subtotal.add('currencyCode');
      });
    });
    query.addField('deliveryGroups', { args: { first: 250 } }, (deliveryGroups: any) => {
      deliveryGroups.add('pageInfo', (pageInfo: any) => {
        pageInfo.add('hasPreviousPage');
        pageInfo.add('hasNextPage');
      });
      deliveryGroups.add('edges', (edges: any) => {
        edges.add('node', (node: any) => {
          node.add('selectedDeliveryOption', (option: any) => {
            option.add('title');
            option.add('description');
            option.add('estimatedCost', (cost: any) => {
              cost.add('amount');
              cost.add('currencyCode');
            });
          });
        });
      });
    });
  }
}
